import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './Menu.module.css'
import { ReactComponent as HomeSvg } from '../../../assets/img/nav/home.svg'
import { ReactComponent as NewsSvg } from '../../../assets/img/nav/news.svg'
import { ReactComponent as CalendarSvg } from '../../../assets/img/nav/calendar.svg'
import { ReactComponent as DocSvg } from '../../../assets/img/nav/doc.svg'
import { ReactComponent as MenuSvg } from '../../../assets/img/nav/menu.svg'

const Menu = () => {
    return (
        <div className={styles.menu}>
            <NavLink to='/' className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}>
                <HomeSvg />
                <div>
                    Главная
                </div>
            </NavLink>
            <NavLink to='/news' className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}>
                <NewsSvg />
                <div>
                    Новости
                </div>
            </NavLink>
            <NavLink to='/documents' className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}>
                <DocSvg />
                <div>
                    Документы
                </div>
            </NavLink>
            <NavLink to='/calendar' className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}>
                <CalendarSvg />
                <div>
                    Календарь
                </div>
            </NavLink>
            <a className={styles.item}>
                <MenuSvg />
                <div>
                    Меню
                </div>
                <div className={styles.subMenu}>
                    <NavLink className={styles.subMenuItem} to='/declaration'>Заявления<div className={styles.circle}></div></NavLink>
                    <NavLink className={styles.subMenuItem} to='/exchange-rates'>Курс валют<div className={styles.circle}></div></NavLink>
                    <NavLink className={styles.subMenuItem} to='/work-calendar'>Производственный календарь<div className={styles.circle}></div></NavLink>
                    <NavLink className={styles.subMenuItem} to='/pause'>Пауза<div className={styles.circle}></div></NavLink>
                    <NavLink className={styles.subMenuItem} to='/tickets'>Вопросы ОППО<div className={styles.circle}></div></NavLink>
                    {/* <NavLink className={styles.subMenuItem} to='/proposal'>Акции<div className={styles.circle}></div></NavLink> */}
                    <NavLink className={styles.subMenuItem} to='/profile'>Личный кабинет<div className={styles.circle}></div></NavLink>
                </div>
            </a>


        </div>
    )
}

export default Menu
